import React, { useState, useEffect } from 'react';
import classNames from 'classnames';

// import { Button } from '../../Atoms';
import { Button } from '../../Atoms';

import { SearchIcon } from '../../Assets';

import './solutions.scss';
import { getMySolutions, getSolutions } from '../../redux/actions/Solutions';
import { connect } from 'react-redux';
import CloseIcon from '../../Assets/CloseIcon';


const Solutions = ({
  getSolutions,
  solutions,
  success,
  loading,
  error,
  getMySolutions,
  solutionsMe,
}) => {
  const [activeTab, setActiveTab] = useState('0');
  const [search, setSearch] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [openIndex, setOpenIndex] = useState(null);
  const [debounceTimer, setDebounceTimer] = useState(null);

const handleButtonClick = (e) => {
  setActiveTab(e.target?.dataset?.value ?? '1');
  if (searchText) {
    if (debounceTimer) clearTimeout(debounceTimer);
    setSearchText('');
    // Optionally re-fetch fresh lists:
    // getSolutions();
    // getMySolutions();
  }
  // Also close any open details when switching tabs
  setOpenIndex(null);
};

  const handleSolutionClick = (index) => {
    // If user clicks the same one again, close it
    setOpenIndex(openIndex === index ? null : index);
  };

  useEffect(() => {
    console.log('Fetching solutions...');
    getSolutions();
    getMySolutions();
  }, []);

// SEARCH CHANGE — accepts event OR raw string safely
const handleChange = (arg) => {
  const val =
    typeof arg === 'string'
      ? arg
      : (arg && arg.target && typeof arg.target.value === 'string')
        ? arg.target.value
        : '';

  setSearchText(val);

  // Clear any pending server search
  if (debounceTimer) clearTimeout(debounceTimer);

  // If cleared, reset lists (or rely on cached arrays)
  if (!val) {
    if (activeTab === '0') getSolutions();
    else getMySolutions();
    return;
  }

  // Debounce server search (optional)
  const t = setTimeout(() => {
    const query = { q: val };
    if (activeTab === '0') getSolutions(query);
    else getMySolutions(query);
  }, 300);
  setDebounceTimer(t);
};

  const toggleSearch = () => {
    setSearch(!search);
    console.log('Search toggled:', !search);
  };

  // const handleClick = (e) => {
  //   window.open(e.target.dataset.value, '_blank');
  // };

const handleKeyUp = (e) => {
  if ((e?.key || e?.code) === 'Enter' && search) {
    if (debounceTimer) clearTimeout(debounceTimer);
    const query = { q: searchText };
    if (activeTab === '0') return getSolutions(query);
    return getMySolutions(query);
  }
};

const baseData = activeTab === '0' ? solutions : solutionsMe;

const normalized = (s) => (s ?? '').toString().toLowerCase().trim();

const stripTags = (s) => normalized(s).replace(/<[^>]*>/g, '');

const toSearchHaystack = (item) => {
  const label = normalized(item.label);
  const desc  = stripTags(item.description); // if plain text, you can just use normalized(item.description)
  return `${label} ${desc}`.trim();
};

const filteredData = searchText
  ? baseData.filter((item) => toSearchHaystack(item).includes(normalized(searchText)))
  : baseData;


useEffect(() => {
  if (openIndex != null && (openIndex < 0 || openIndex >= filteredData.length)) {
    setOpenIndex(null);
  }
}, [filteredData.length, openIndex]);


const classes = classNames('search-wrapper', { 'search-input': search });

console.log(filteredData);

function isPdf(url = "") {
  try {
    const u = url.toLowerCase();
    return u.includes(".pdf") || u.includes("application/pdf");
  } catch {
    return false;
  }
}

function isImage(url = "") {
  try {
    const u = url.toLowerCase();
    return (
      u.includes(".jpg") ||
      u.includes(".jpeg") ||
      u.includes(".png") ||
      u.includes(".gif") ||
      u.includes(".webp") ||
      u.includes(".svg") ||
      u.includes("image/")
    );
  } catch {
    return false;
  }
}

function isYouTube(url = "") {
  try {
    const u = new URL(url);
    const host = u.hostname.replace(/^www\./, "");
    return (
      host === "youtube.com" ||
      host === "youtu.be" ||
      host === "m.youtube.com"
    );
  } catch {
    return false;
  }
}

function toYouTubeEmbed(url = "") {
  try {
    const u = new URL(url);
    const host = u.hostname.replace(/^www\./, "");
    let id = "";

    if (host === "youtu.be") {
      id = u.pathname.slice(1);
    } else {
      // youtube.com/* variants
      if (u.pathname.startsWith("/watch")) id = u.searchParams.get("v") || "";
      else if (u.pathname.startsWith("/embed/")) id = u.pathname.split("/")[2] || "";
      else if (u.pathname.startsWith("/shorts/")) id = u.pathname.split("/")[2] || "";
    }

    return id ? `https://www.youtube.com/embed/${id}` : null;
  } catch {
    return null;
  }
}


  return (
    <div className="main-solutions-wrapper">
      <header>
        <h4>Peak Pathways</h4>
        <div className={classes}>
          <span onClick={toggleSearch}>
            {search ? <CloseIcon /> : <SearchIcon />}
          </span>
          <input
            value={searchText}
            onChange={handleChange}
            className="search-text"
            onKeyUp={handleKeyUp}
            placeholder="search"
          />
        </div>
        
      </header>

      <p>
        Below you will find a curated list of learning moments that we have made
        with your well-being in mind.
      </p>
      <div className="d-flex custom-btn-group">
        <Button
          className="mr-2"
          size="form-md"
          color={activeTab === '0' ? 'blue' : 'white'}
          style={{ width: 185 }}
          data-value={0}
          onClick={handleButtonClick}
        >
          All Action Steps
        </Button>
        <Button
          size="form-md"
          data-value={1}
          color={activeTab === '1' ? 'blue' : 'white'}
          style={{ width: 185 }}
          onClick={handleButtonClick}
        >
          Recommended For You
        </Button>
      </div>

    <div className="solution-view-details">
      <ul>
        {filteredData.map((solution, index) => (

        <div key={index} style={{ marginBottom: "24px" }}>
        
        {/* Row 1 */}
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderBottom: "1px solid #ccc",
        padding: "8px 0",
      }}
    >

        <h6>{solution.label}</h6>
          <Button
          size="sm"
          color="white"
          onClick={() => handleSolutionClick(index)}
            >
          {openIndex === index ? "HIDE" : "VIEW"}
          </Button>
    </div>
    <div
      style={{
        marginTop: "8px",
        padding: "8px",
        borderRadius: "4px",
      }}
    >
            {openIndex === index && (
  <div style={{ marginTop: "1rem" }}>
    {(() => {
      const href = solution.link || solution.url || solution.resource_url || "";
      if (!href) return <em>No link available.</em>;

      if (isPdf(href)) {
        // PDF embed
        return (
          <div className="embed embed--pdf" aria-label="PDF preview">
            {/* Try native PDF first */}
            <embed src={href} type="application/pdf" />
          </div>
        );
      }

      if (isImage(href)) {
        return (
          <div className="embed embed--image" aria-label="Image preview">
            <img
              src={href}
              alt={solution.label || "Resource image"}
              loading="lazy"
              style={{
                maxWidth: "100%",
                height: "auto",
                display: "block",
                borderRadius: "6px",
              }}
            />
          </div>
        );
      }

      if (isYouTube(href)) {
        const embedUrl = toYouTubeEmbed(href);
        if (embedUrl) {
          return (
            <div className="embed embed--16x9" aria-label="Video player">
              <iframe
                src={embedUrl}
                title={`Video - ${solution.label || "Action Step"}`}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              />
            </div>
          );
        }
      }

      // Fallback: not PDF / not YouTube or couldn’t embed → show a button
      return (
        <Button
          size="form-md"
          color="blue"
          onClick={() => window.open(href, "_blank", "noopener,noreferrer")}
        >
          Open Resource
        </Button>
      );
    })()}
  </div>
)}

    </div>
  </div>

        ))}

      </ul>
      
      
    </div>

    </div>
  );
};

const mapStateToProps = (state) => {
  console.log('Redux state:', state);
  return {
    solutions: state.solutions.solutions,
    solutionsMe: state.solutions.solutionsMe,
    loading: state.solutions.getSolutions.loading,
    success: state.solutions.getSolutions.success,
    error: state.solutions.getSolutions.error,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getSolutions: (query) => {
    console.log('Dispatching getSolutions with query:', query);
    dispatch(getSolutions(query));
  },
  getMySolutions: (query) => {
    console.log('Dispatching getMySolutions with query:', query);
    dispatch(getMySolutions(query));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Solutions);